import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Section, Text, Badge, Link, Icon, Flex} from 'components/UIKit';
import * as locales from '../../locales';
import {ListingShop} from '../../types';
import {ListingSummary} from '../ListingSummary';
import styles from './SoldListings.scss';

export interface SoldListingsProps {
  sold: ListingShop[];
  link: string;
}

class SoldListingsComponent extends React.Component<SoldListingsProps & WithI18nProps> {
  renderSummaryTopButton = () => {
    const {i18n} = this.props;
    return <Badge type="lightGrey" text={i18n.translate('sold')} />;
  };

  renderSectionTopButton = () => {
    const {link, i18n} = this.props;

    return (
      <Flex alignItems="center" className={styles.ViewAll}>
        <Link url={link} text={i18n.translate('viewAll')} resetMargin />
        <Icon icon="chevronRight" size={16} className={styles.Icon} />
      </Flex>
    );
  };

  render() {
    const {sold = [], link, i18n} = this.props;

    return (
      <Section spacing="small" fullWidth>
        <Flex className={styles.Header} justifyContent="space-between" alignItems="center">
          <Text text={i18n.translate('soldBusinesses')} type="h5" component="h2" resetMargin />
          <div>
            <Link url={link} text={i18n.translate('viewAll')} forcePink />
            <Icon icon="chevronRight" size={16} className={styles.Icon} fill="#eb2866" />
          </div>
        </Flex>
        <ul className={styles.List}>
          {sold.map((listing, i) => (
            <ListingSummary
              key={listing.id}
              hideBorder={i === sold.length - 1}
              linkTo
              listing={listing}
              hidePrice
              renderTopButton={this.renderSummaryTopButton}
            />
          ))}
        </ul>
      </Section>
    );
  }
}

export const SoldListings = withI18n({
  id: 'Listing',
  fallback: locales.en,
})(SoldListingsComponent);

export default SoldListings;
